module.exports = __webpack_public_path__ + "img/ticket-later.ed41b04a.svg";